export default "__VITE_ASSET__dzaTnBgV__"